import dayjs from "dayjs";

export const DATE_FORMATE = "YYYY-MM-DD";

export const getDateRange = (task) => {
  const defaultDateRange =
    task.startDate && task.endDate
      ? [dayjs(task.startDate, DATE_FORMATE), dayjs(task.endDate, DATE_FORMATE)]
      : [];

  return {
    defaultDateRange,
  };
};

export const getIsTimeLoggedAgainstMilestone = (loggedInstances, milestone) => {
  if (!loggedInstances || !milestone?.name) return false;
  return loggedInstances.some((log) => {
    // Check if deliverable matches the milestone name
    const isMatchingDeliverable =
      log?.deliverable?.trim()?.toLowerCase() === milestone?.name?.trim()?.toLowerCase();
    if (!isMatchingDeliverable) return false;
    // Ensure `hours` is an array and check if any entry has hours > 0
    return Array.isArray(log.hours) && log.hours.some((entry) => Number(entry?.hours) > 0);
  });
};

